// extracted by mini-css-extract-plugin
export default {"formInput":"FormInput_formInput__r6Qxg","invalidInput":"FormInput_invalidInput__800IJ","vectorImg":"FormInput_vectorImg__zqk9d"};